module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_icons/icn-directly-2665f965022d2eb9ea3ff9f60af632fa.svg";